import getDefaultState from './defaults';

export default getDefaultState();
